import React from 'react';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';
import { datetimeFormat12h } from '../../../../scripts/date.time.format.script';

export interface AppInventoryViewDateProps {
  display?: string,
  record: any | Service | Product
};

const AppInventoryViewDate: React.FunctionComponent<AppInventoryViewDateProps> = ({display, record}) => {
  const {lang} = StateLanguage()

  return (
    <div className={`card card-flush ${display || ""}`}>
      <div className="card-body">
        <div className="pb-2">
          <div className="text-muted fs-8">{lang.labels.createdAt}:</div>
          <div className="fw-bold">{datetimeFormat12h(lang.code, record.created_at)}</div>
        </div>
        <div className="pb-0">
          <div className="text-muted fs-8">{lang.labels.updatedAt}:</div>
          <div className="fw-bold">{datetimeFormat12h(lang.code, record.updated_at)}</div>
        </div>
      </div>
    </div>
  )
};

export default AppInventoryViewDate;
